import _round from 'lodash/round';

import { addThousandsSeparator, formatDollarsKpi, getKpiAmount } from '..';

interface FormatKpiStringInput {
    kpis: ProKpis;
    kpiType: keyof ProKpis | 'earnings_misc_bulk';
    asDollars: boolean;
}

export const formatKpiString = ({
    kpis,
    kpiType,
    asDollars,
}: FormatKpiStringInput): string => {
    const amount = getKpiAmount({ kpis, kpiType });

    if (asDollars) {
        return formatDollarsKpi(amount);
    }

    return addThousandsSeparator(_round(amount, 2));
};
